import { CircleAlert, RefreshCw } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { toast } from "sonner";

type Props = {
  onRetry: () => Promise<void>;
};

export const InvoiceErrorAlert = ({ onRetry }: Props) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const handleRetry = async () => {
    setLoading(true);
    try {
      await onRetry();
      toast(t("retry_extraction.success"), { duration: 10000 });
    } catch (error) {
      toast.error(t("retry_extraction.error"), { richColors: true });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Alert variant="warning">
      <AlertTitle className="font-bold flex items-center">
        <CircleAlert size={16} className="mr-2" />
        {t("invoice_details.error_alert.title")}
      </AlertTitle>
      <AlertDescription className="flex flex-col gap-2">
        <div>{t("invoice_details.error_alert.description")}</div>
        <div className="flex justify-end">
          <Button className="gap-1" onClick={handleRetry} disabled={loading}>
            <RefreshCw
              className={cn(loading && "animate-spin", "mr-2 h-4 w-4")}
            />
            {t("invoice_details.error_alert.retry")}
          </Button>
        </div>
      </AlertDescription>
    </Alert>
  );
};
